import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import en from './locales/en.json';
import gu from './locales/gu.json';
import hi from './locales/hi.json';

const resources = {
  en: {
    translation: en
  },
  gu: {
    translation: gu
  },
  hi: {
    translation: hi
  }
};

// Get saved language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem('i18nextLng') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage, // use saved language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    // Enable language persistence
    saveMissing: false
  });

// Listen for language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;
